import { SortDirection } from '../enums/sort-direction.enum'; // Adjust the path as needed
import { TaskSortingProperties } from '../enums/task-sorting-properties.enum'; // Adjust the path as needed
import { TaskState } from '../enums/task-state.enum';
import { SubjectType } from '../enums/subject-type.enum';
import { WorkflowArea } from '../enums/workflow-area.enum';

export interface TasksFilter {
    assignedTo?: string[];

    area?: WorkflowArea;

    taskType?: TaskType;

    taskStates?: TaskState[];

    taskName?: string;

    sectionName?: string;

    companyIds?: string[];

    /** REV-22155 — filter "Typ"; COMPANY also finds tasks without type. */
    subjectTypes?: SubjectType[];

    /** REV-22155 — filter "Mandant" for persons; together with `companyIds` a task matches either. */
    personIds?: string[];

    dateRange?: {
        startDate: string | null;
        endDate: string | null;
    }[];

    offset?: number;

    limit?: number;

    sortBy?: TaskSortingProperties;

    sortOrder?: SortDirection;
}
